import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { CommunityInviteRow } from './getCommunityInvitesTableColumns'

interface CommunityInviteExpandableRowProps {
  row: CommunityInviteRow
}

export const PROGRAM_DETAIL_ROW_HEIGHT = 76

const CommunityInviteExpandableRow: React.FC<
  CommunityInviteExpandableRowProps
> = ({ row }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: theme.palette.action.hover,
      }}
    >
      {row.programs.map((program) => (
        <Box
          key={program.programKey}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'var(--actionable-table-columns)',
            alignItems: 'center',
            minHeight: PROGRAM_DETAIL_ROW_HEIGHT,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Box
            sx={{
              gridColumn: 6,
              px: '0.625rem',
            }}
          >
            <Typography>{program.programType}</Typography>
          </Box>

          <Box
            sx={{
              gridColumn: 7,
              px: '0.625rem',
            }}
          >
            <Typography>{program.offeredSpots}</Typography>
          </Box>

          <Box
            sx={{
              gridColumn: 8,
              px: '0.625rem',
            }}
          >
            <Typography>{program.skippedSpots ?? 0}</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default CommunityInviteExpandableRow
